exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green {\n    background-color:rgb(151,159,0);\n}\n\n.blue {\n    background-color:rgb(1, 85, 183);\n}\n\n.violet {\n    background-color:rgb(113, 49, 136);\n}\n\n.orange {\n    background-color:rgb(237, 123, 1);\n}\n\n.fa {\n    font-size:2rem;\n    cursor:pointer;\n}\n\n.lead {\n    padding:0 4rem;\n    text-align:center;\n}\n\nh4 {\n    padding-right:4rem;\n}\n\n.container-image {\n    padding:3rem;\n    border-radius:1rem;\n}\n\n.container-heading .fa {\n\tfont-size:5rem;\n}\n\n.container-heading.innovationFilter .fa {\n\tcolor:rgb(170, 179, 0);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/innovation-filter/innovation-filter.component.css
// module id = ../../../../../src/app/base/components/canvas/components/innovation-filter/innovation-filter.component.css
// module chunks = main